import { defineAsyncComponent, markRaw } from "vue";
import type { TileConfigType } from "@/modules/tiles/tileConfigs";
import { ENV } from "@/ENV";

export const tileConfigs: TileConfigType = {
  BDERubenTile: {
    active:
      ENV.VITE_APP_INSTANCE_KEY.includes("tkiberica") || ENV.VITE_APP_INSTANCE_KEY.includes("rene"),
    settingsModule: markRaw(
      defineAsyncComponent(() => import("./components/Tiles/SQDCBDERubenTileSettings.vue")),
    ),
    component: markRaw(defineAsyncComponent(() => import("./components/Tiles/BDERubenTile.vue"))),
    icon: "fas fa-vest-patches",
  },
  BDERubenTileSales: {
    active:
      ENV.VITE_APP_INSTANCE_KEY.includes("tkiberica") || ENV.VITE_APP_INSTANCE_KEY.includes("rene"),
    settingsModule: markRaw(
      defineAsyncComponent(() => import("./components/Tiles/SQDCBDERubenTileSalesSettings.vue")),
    ),
    component: markRaw(
      defineAsyncComponent(() => import("./components/Tiles/BDERubenTileSales.vue")),
    ),
    icon: "fas fa-glass-cheers",
  },
};
